<template>
  <view flex="dir:left cross:center" :style="style">
    <el-select v-model="value" :placeholder="placeholder" :size="size" @change="updateValue">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
  </view>
</template>
<script lang="ts" setup>
import { ref } from "vue"
import { useDark, useToggle } from "@vueuse/core"
import { ElSelect, ElOption } from "element-plus"
import { onMounted, computed } from "vue"
import moment from "moment"

const props = withDefaults(
  defineProps<{
    style?: { [key: string]: string }
    size?: "large" | "default" | "small"
    theme?: "dark" | "light"
    placeholder?: string
    fromDay?: string
    dayType:
      | "today"
      | "yesterday"
      | "thisWeek"
      | "thisMonth"
      | "lastMonth"
      | "lastWeek"
      | "thisQuarter"
      | "thisYear"
      | "latestnDays"
      | "latestnWeeks"
      | "latestnMonths"
      | "pastnDays"
      | "futurenDays"
    n?: number
    selectDate: string
  }>(),
  {
    style: () => ({}),
    size: () => "default",
    theme: () => "dark",
    placeholder: () => "请选择日期",
    fromDay: undefined,
    dayType: () => "pastnDays",
    n: () => 7,
    selectDate: () => "",
  },
)

const emits = defineEmits<{
  (e: "update:selectDate", date: string): void
}>()

const value = ref(props.selectDate)

const updateValue = (val: string) => {
  emits("update:selectDate", val)
  value.value = val
}

const options = computed(() => {
  const dayType = props.dayType
  const n = props.n
  let start = moment(props.fromDay)
  let end = moment()
  switch (dayType) {
    case "today":
      end = moment(props.fromDay).endOf("day")
      break
    case "yesterday":
      end = moment(props.fromDay).subtract(1, "days").endOf("day")
      break
    case "thisWeek":
      start = moment(props.fromDay).startOf("week")
      end = moment(props.fromDay).endOf("week")
      break
    case "thisMonth":
      start = moment(props.fromDay).startOf("month")
      end = moment(props.fromDay).endOf("month")
      break
    case "lastMonth":
      start = moment(props.fromDay).subtract(1, "months").startOf("month")
      end = moment(props.fromDay).subtract(1, "months").endOf("month")
      break
    case "lastWeek":
      start = moment(props.fromDay).subtract(1, "weeks").startOf("week")
      end = moment(props.fromDay).subtract(1, "weeks").endOf("week")
      break
    case "thisQuarter":
      start = moment(props.fromDay).startOf("quarter")
      end = moment(props.fromDay).endOf("quarter")
      break
    case "thisYear":
      start = moment(props.fromDay).startOf("year")
      end = moment(props.fromDay).endOf("year")
      break
    case "latestnDays":
      start = moment(props.fromDay).subtract(n, "days").startOf("day")
      end = moment(props.fromDay).endOf("day")
      break
    case "latestnWeeks":
      start = moment(props.fromDay).subtract(n, "weeks").startOf("week")
      end = moment(props.fromDay).endOf("week")
      break
    case "latestnMonths":
      start = moment(props.fromDay).subtract(n, "months").startOf("month")
      end = moment(props.fromDay).endOf("month")
      break
    case "pastnDays":
      start = moment(props.fromDay).subtract(n, "days").startOf("day")
      end = moment(props.fromDay).subtract(1, "days").endOf("day")
      break
    // 将来n天
    case "futurenDays":
      start = moment(props.fromDay).startOf("day")
      end = moment(props.fromDay).add(n, "days").endOf("day")
      break
  }
  const options: { value: string; label: string }[] = []
  while (start.isBefore(end)) {
    options.push({
      value: start.format("YYYY-MM-DD"),
      label: start.format("YYYY-MM-DD"),
    })
    start = start.add(1, "days")
  }
  console.log(options)
  return options
})
onMounted(() => {
  const isDark = useDark()
  if (props.theme === "dark") {
    isDark.value = true
  } else if (props.theme === "light") {
    isDark.value = false
  }
  useToggle(isDark)
})
</script>
